import { unsavedChangesGuard } from './guards/unsaved-changes.guard';
import { Routes } from '@angular/router';
import { AuthTemplateComponent } from './templates/auth-template/auth-template.component';
import { MainTemplateComponent } from './templates/main-template/main-template.component';
import { AuthGuard } from './guards/auth.guard';
import { GuestGuard } from './guards/guest.guard';

export const routes: Routes = [
  {
    path: 'update_indent_price/:purchaseIndentInfoId/:supplierId',
    loadComponent: () =>
      import('./pages/manage-inventory/update-indent-price/update-indent-price.component').then(
        (m) => m.UpdateIndentPriceComponent,
      ),
  },
  {
    path: '',
    component: MainTemplateComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'om-operation',
        canDeactivate: [unsavedChangesGuard],
        loadComponent: () =>
          import('./pages/om-operation/om-operation.component').then(
            (m) => m.OmOperationComponent,
          ),
      },
      {
        path: 'om-operation/:id',
        canDeactivate: [unsavedChangesGuard],
        loadComponent: () =>
          import('./pages/om-operation/om-operation.component').then(
            (m) => m.OmOperationComponent,
          ),
      },
      {
        path: 'oandm',
        children: [
          {
            path: 'demands/create',
            loadComponent: () =>
              import('./pages/oandm-demand/oandm-demand-create/oandm-demand-create.component').then(
                (m) => m.OandmDemandCreateComponent,
              ),
          },
          {
            path: 'demands/edit/:id',
            loadComponent: () =>
              import('./pages/oandm-demand/oandm-demand-create/oandm-demand-create.component').then(
                (m) => m.OandmDemandCreateComponent,
              ),
          },
          {
            path: 'demands',
            loadComponent: () =>
              import('./pages/oandm-demand/oandm-demand-list/oandm-demand-list.component').then(
                (m) => m.OandmDemandListComponent,
              ),
          },
          {
            path: 'site-inventory/:oandmId',
            loadComponent: () =>
              import('./pages/oandm-site-inventory/oandm-site-inventory.component').then(
                (m) => m.OandmSiteInventoryComponent,
              ),
          },
          {
            path: 'site-inventory',
            loadComponent: () =>
              import('./pages/oandm-site-inventory/oandm-site-inventory.component').then(
                (m) => m.OandmSiteInventoryComponent,
              ),
          },
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () =>
              import('./pages/oandm-list/oandm-list.component').then(
                (m) => m.OandmListComponent,
              ),
          },
        ],
      },
      {
        path: 'oandm/site-inventory/:oandmId',
        loadComponent: () =>
          import('./pages/oandm-site-inventory/oandm-site-inventory.component').then(
            (m) => m.OandmSiteInventoryComponent,
          ),
      },
      {
        path: 'oandm/site-inventory',
        loadComponent: () =>
          import('./pages/oandm-site-inventory/oandm-site-inventory.component').then(
            (m) => m.OandmSiteInventoryComponent,
          ),
      },
      {
        path: '',
        loadComponent: () =>
          import('./pages/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent,
          ),
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import('./pages/notifications/notifications.component').then(
            (m) => m.NotificationsComponent,
          ),
      },
      {
        path: 'task-manager',
        loadComponent: () =>
          import('./pages/task-manager/task-manager.component').then(
            (m) => m.TaskManagerComponent,
          ),
      },
      {
        path: 'company',
        children: [
          {
            path: 'list',
            loadComponent: () =>
              import('./pages/company/company-list/company-list.component').then(
                (m) => m.CompanyListComponent,
              ),
          },
          {
            path: 'add',
            loadComponent: () =>
              import('./pages/company/company-add/company-add.component').then(
                (m) => m.CompanyAddComponent,
              ),
          },
        ],
      },
      {
        path: 'employees',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/employee-manage/employee-list/employee-list.component').then(
                (m) => m.EmployeeListComponent,
              ),
          },
          {
            path: 'add',
            loadComponent: () =>
              import('./pages/employee-manage/employee-add/employee-manage.component').then(
                (m) => m.EmployeeManageComponent,
              ),
          },
        ],
      },
      {
        path: 'tasks',
        loadComponent: () =>
          import('./pages/task-master/task-master.component').then(
            (m) => m.TaskMasterComponent,
          ),
      },
      {
        path: 'inventory',
        children: [
          {
            path: 'brands',
            loadComponent: () =>
              import('./pages/manage-inventory/manage-brands/manage-brands.component').then(
                (m) => m.ManageBrandsComponent,
              ),
          },
          {
            path: 'categories',
            loadComponent: () =>
              import('./pages/manage-inventory/manage-category/manage-category.component').then(
                (m) => m.ManageCategoryComponent,
              ),
          },
          {
            path: 'stores',
            loadComponent: () =>
              import('./pages/manage-inventory/manage-stores/manage-stores.component').then(
                (m) => m.ManageStoresComponent,
              ),
          },
          {
            path: 'parts-list',
            loadComponent: () =>
              import('./pages/manage-inventory/manage-parts-list/list-parts/list-parts.component').then(
                (m) => m.ListPartsComponent,
              ),
          },
          {
            path: 'parts-upload-invalid',
            loadComponent: () =>
              import('./pages/manage-inventory/manage-parts-list/invalid-parts-upload/invalid-parts-upload.component').then(
                (m) => m.InvalidPartsUploadComponent,
              ),
          },
          {
            path: 'parts-add',
            loadComponent: () =>
              import('./pages/manage-inventory/manage-parts-list/add-parts/add-parts.component').then(
                (m) => m.AddPartsComponent,
              ),
          },
          {
            path: 'parts-history',
            loadComponent: () =>
              import('./pages/manage-inventory/manage-parts-list/parts-history/parts-history.component').then(
                (m) => m.PartsHistoryComponent,
              ),
          },
          {
            path: 'bom-list',
            loadComponent: () =>
              import('./pages/manage-inventory/bom/list-bom/list-bom.component').then(
                (m) => m.ListBomComponent,
              ),
          },
          {
            path: 'bom-add',
            loadComponent: () =>
              import('./pages/manage-inventory/bom/manage-bom/manage-bom.component').then(
                (m) => m.ManageBomComponent,
              ),
          },
          {
            path: 'bom-edit/:id',
            loadComponent: () =>
              import('./pages/manage-inventory/bom/manage-bom/manage-bom.component').then(
                (m) => m.ManageBomComponent,
              ),
          },
          {
            path: 'purchase-indent/list',
            loadComponent: () =>
              import('./pages/manage-inventory/list-purchase-indent/list-purchase-indent.component').then(
                (m) => m.ListPurchaseIndentComponent,
              ),
          },
          {
            path: 'purchase-indent',
            canDeactivate: [unsavedChangesGuard],
            loadComponent: () =>
              import('./pages/manage-inventory/create-purchase-indent/create-purchase-indent.component').then(
                (m) => m.CreatePurchaseIndentComponent,
              ),
          },
          {
            path: 'purchase-indent/:id',
            canDeactivate: [unsavedChangesGuard],
            loadComponent: () =>
              import('./pages/manage-inventory/create-purchase-indent/create-purchase-indent.component').then(
                (m) => m.CreatePurchaseIndentComponent,
              ),
          },
          {
            path: 'purchase-order',
            loadComponent: () =>
              import('./pages/manage-inventory/list-purchase-order/list-purchase-order.component').then(
                (m) => m.ListPurchaseOrderComponent,
              ),
          },
          {
            path: 'in-house-manufacturing/:id',
            loadComponent: () =>
              import('./pages/manage-inventory/in-house-manufacturing/manufacturing-request-detail/manufacturing-request-detail.component').then(
                (m) => m.ManufacturingRequestDetailComponent,
              ),
          },
          {
            path: 'job-cards',
            loadComponent: () =>
              import('./pages/manage-inventory/job-card/job-card.component').then(
                (m) => m.JobCardComponent,
              ),
          },
          {
            path: 'in-house-manufacturing',
            loadComponent: () =>
              import('./pages/manage-inventory/in-house-manufacturing/in-house-manufacturing.component').then(
                (m) => m.InHouseManufacturingComponent,
              ),
          },
          {
            path: 'purchase-order/create',
            canDeactivate: [unsavedChangesGuard],
            loadComponent: () =>
              import('./pages/manage-inventory/create-purchase-order/create-purchase-order.component').then(
                (m) => m.CreatePurchaseOrderComponent,
              ),
          },
          {
            path: 'purchase-order/:id/qc',
            loadComponent: () =>
              import('./pages/manage-inventory/purchase-order-qc/purchase-order-qc.component').then(
                (m) => m.PurchaseOrderQcComponent,
              ),
          },
          {
            path: 'purchase-order/:id/payments',
            loadComponent: () =>
              import('./pages/manage-inventory/purchase-order-payments/purchase-order-payments.component').then(
                (m) => m.PurchaseOrderPaymentsComponent,
              ),
          },
          {
            path: 'purchase-order/:id',
            loadComponent: () =>
              import('./pages/manage-inventory/detail-purchase-order/detail-purchase-order.component').then(
                (m) => m.DetailPurchaseOrderComponent,
              ),
          },
          {
            path: 'model-list',
            loadComponent: () =>
              import('./pages/manage-inventory/models/list-model/list-model.component').then(
                (m) => m.ListModelComponent,
              ),
          },
          {
            path: 'model-add',
            loadComponent: () =>
              import('./pages/manage-inventory/models/create-model/create-model.component').then(
                (m) => m.CreateModelComponent,
              ),
          },
          {
            path: 'model-edit/:id',
            loadComponent: () =>
              import('./pages/manage-inventory/models/create-model/create-model.component').then(
                (m) => m.CreateModelComponent,
              ),
          },
          {
            path: 'invert-vouchar/list',
            loadComponent: () =>
              import('./pages/manage-vouchars/invert/invert.component').then(
                (m) => m.InvertComponent,
              ),
          },
          {
            path: 'invert-vouchar/add',
            loadComponent: () =>
              import('./pages/manage-vouchars/create-manual-invert/create-manual-invert.component').then(
                (m) => m.CreateManualInvertComponent,
              ),
          },
          {
            path: 'outword-vouchar/list',
            loadComponent: () =>
              import('./pages/manage-vouchars/outword/outword.component').then(
                (m) => m.OutwordComponent,
              ),
          },
          {
            path: 'outword-vouchar/add',
            loadComponent: () =>
              import('./pages/manage-vouchars/create-outword/create-outword.component').then(
                (m) => m.CreateOutwordComponent,
              ),
          },
          {
            path: 'outword-vouchar/edit/:id',
            loadComponent: () =>
              import('./pages/manage-vouchars/create-outword/create-outword.component').then(
                (m) => m.CreateOutwordComponent,
              ),
          },
        ],
      },
      {
        path: 'roles',
        loadComponent: () =>
          import('./pages/roles/roles.component').then((m) => m.RolesComponent),
      },
      {
        path: 'permissions/:id',
        loadComponent: () =>
          import('./pages/roles/manage-permissions/manage-permissions.component').then(
            (m) => m.ManagePermissionsComponent,
          ),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./pages/employee-manage/profile/profile.component').then(
            (m) => m.ProfileComponent,
          ),
      },
      {
        path: 'team-type',
        loadComponent: () =>
          import('./pages/employee-manage/team-type/team-type.component').then(
            (m) => m.TeamTypeComponent,
          ),
      },
      {
        path: 'team',
        loadComponent: () =>
          import('./pages/employee-manage/manage-team/manage-team.component').then(
            (m) => m.ManageTeamComponent,
          ),
      },
      {
        path: 'team/:id',
        loadComponent: () =>
          import('./pages/employee-manage/team-detail/team-detail.component').then(
            (m) => m.TeamDetailComponent,
          ),
      },
      {
        path: 'departments',
        loadComponent: () =>
          import('./pages/employee-manage/manage-departments/manage-departments.component').then(
            (m) => m.ManageDepartmentsComponent,
          ),
      },
      {
        path: 'libraries',
        loadComponent: () =>
          import('./pages/library-mgmt/library-mgmt.component').then(
            (m) => m.LibraryMgmtComponent,
          ),
      },
      {
        path: 'libraries/files/:id',
        loadComponent: () =>
          import('./pages/library-mgmt/library-files/library-files.component').then(
            (m) => m.LibraryFilesComponent,
          ),
      },
      {
        path: 'customers',
        loadComponent: () =>
          import('./pages/customer-list/customer-list.component').then(
            (m) => m.CustomerListComponent,
          ),
      },
      {
        path: 'transportation',
        loadComponent: () =>
          import('./pages/transportation-list/transportation-list.component').then(
            (m) => m.TransportationListComponent,
          ),
      },
      {
        path: 'machine-fleet/add',
        loadComponent: () =>
          import('./pages/machine-fleet/machine-fleet.component').then(
            (m) => m.MachineFleetComponent,
          ),
      },
      {
        path: 'machine-fleet/edit/:id',
        loadComponent: () =>
          import('./pages/machine-fleet/machine-fleet.component').then(
            (m) => m.MachineFleetComponent,
          ),
      },
      {
        path: 'machine-fleet',
        loadComponent: () =>
          import('./pages/machine-fleet-list/machine-fleet-list.component').then(
            (m) => m.MachineFleetListComponent,
          ),
      },
      {
        path: 'suppliers',
        loadComponent: () =>
          import('./pages/supplier-list/supplier-list.component').then(
            (m) => m.SupplierListComponent,
          ),
      },
      {
        path: 'ledger-entries',
        loadComponent: () =>
          import('./pages/ledger-entries/ledger-entries.component').then(
            (m) => m.LedgerEntriesComponent,
          ),
      },
      {
        path: 'ledgers',
        loadComponent: () =>
          import('./pages/ledger-entries/ledger-entries.component').then(
            (m) => m.LedgerEntriesComponent,
          ),
      },
      {
        path: 'terms-and-conditions',
        loadComponent: () =>
          import('./pages/manage-terms-and-condition/manage-terms-and-condition.component').then(
            (m) => m.ManageTermsAndConditionComponent,
          ),
      },
      {
        path: 'quotations',
        children: [
          {
            path: 'list',
            loadComponent: () =>
              import('./pages/manage-production/list-quotation/list-quotation.component').then(
                (m) => m.ListQuotationComponent,
              ),
          },
          {
            path: 'create',
            canDeactivate: [unsavedChangesGuard],
            loadComponent: () =>
              import('./pages/manage-production/create-quotation/create-quotation.component').then(
                (m) => m.QuotationCreateComponent,
              ),
          },
          {
            path: 'create/:id',
            canDeactivate: [unsavedChangesGuard],
            loadComponent: () =>
              import('./pages/manage-production/create-quotation/create-quotation.component').then(
                (m) => m.QuotationCreateComponent,
              ),
          },
        ],
      },

      {
        path: 'leads',
        children: [
          {
            path: 'list',
            loadComponent: () =>
              import('./pages/manage-production/manage-lead/lead-list/lead-list.component').then(
                (m) => m.LeadListComponent,
              ),
          },
          {
            path: 'create',
            canDeactivate: [unsavedChangesGuard],
            loadComponent: () =>
              import('./pages/manage-production/manage-lead/create-lead/create-lead.component').then(
                (m) => m.CreateLeadComponent,
              ),
          },
          {
            path: 'manage/:id',
            loadComponent: () =>
              import('./pages/manage-production/manage-lead/manage-lead.component').then(
                (m) => m.ManageLeadComponent,
              ),
          },
          {
            path: 'edit/:id',
            canDeactivate: [unsavedChangesGuard],
            loadComponent: () =>
              import('./pages/manage-production/manage-lead/create-lead/create-lead.component').then(
                (m) => m.CreateLeadComponent,
              ),
          },
        ],
      },
      {
        path: 'production/orders',
        children: [
          {
            path: 'list',
            loadComponent: () =>
              import('./pages/manage-production/list-production-order/list-production-order.component').then(
                (m) => m.ListProductionOrderComponent,
              ),
          },
          {
            path: 'new',
            canDeactivate: [unsavedChangesGuard],
            loadComponent: () =>
              import('./pages/manage-production/create-production-order/create-production-order.component').then(
                (m) => m.CreateProductionOrderComponent,
              ),
          },
          {
            path: 'edit/:id',
            canDeactivate: [unsavedChangesGuard],
            loadComponent: () =>
              import('./pages/manage-production/create-production-order/create-production-order.component').then(
                (m) => m.CreateProductionOrderComponent,
              ),
          },
          {
            path: 'dashboard/:id',
            loadComponent: () =>
              import('./components/production-execution-tasks/production-execution-tasks.component').then(
                (m) => m.ProductionExecutionTasksComponent,
              ),
          },
          {
            path: ':id/vehicle-documents-processing',
            loadComponent: () =>
              import('./pages/manage-production/vehicle-documents-processing/vehicle-documents-processing.component').then(
                (m) => m.VehicleDocumentsProcessingComponent,
              ),
          },
          {
            path: ':id/pi',
            loadComponent: () =>
              import('./pages/manage-production/manage-proforma-invoices/manage-proforma-invoices.component').then(
                (m) => m.ManageProformaInvoicesComponent,
              ),
          },
        ],
      },
      {
        path: 'production/stock-demand',
        loadComponent: () =>
          import('./pages/manage-production/stock-demand/stock-demand.component').then(
            (m) => m.StockDemandComponent,
          ),
      },
      {
        path: 'custome-charges',
        loadComponent: () =>
          import('./pages/manage-production/manage-custome-charges/manage-custome-charges.component').then(
            (m) => m.ManageCustomeChargesComponent,
          ),
      },
      {
        path: 'sub-assembly-master/add',
        data: { assemblyType: 'sub-assembly' },
        loadComponent: () =>
          import('./pages/assembly-master/assembly-editor/assembly-editor.component').then(
            (m) => m.AssemblyEditorComponent,
          ),
      },
      {
        path: 'sub-assembly-master/:id/edit',
        data: { assemblyType: 'sub-assembly' },
        loadComponent: () =>
          import('./pages/assembly-master/assembly-editor/assembly-editor.component').then(
            (m) => m.AssemblyEditorComponent,
          ),
      },
      {
        path: 'main-assembly-master/add',
        data: { assemblyType: 'main-assembly' },
        loadComponent: () =>
          import('./pages/assembly-master/assembly-editor/assembly-editor.component').then(
            (m) => m.AssemblyEditorComponent,
          ),
      },
      {
        path: 'main-assembly-master/:id/edit',
        data: { assemblyType: 'main-assembly' },
        loadComponent: () =>
          import('./pages/assembly-master/assembly-editor/assembly-editor.component').then(
            (m) => m.AssemblyEditorComponent,
          ),
      },
      {
        path: 'machine-assembly-master/add',
        data: { assemblyType: 'machine-assembly' },
        loadComponent: () =>
          import('./pages/assembly-master/assembly-editor/assembly-editor.component').then(
            (m) => m.AssemblyEditorComponent,
          ),
      },
      {
        path: 'machine-assembly-master/:id/edit',
        data: { assemblyType: 'machine-assembly' },
        loadComponent: () =>
          import('./pages/assembly-master/assembly-editor/assembly-editor.component').then(
            (m) => m.AssemblyEditorComponent,
          ),
      },
      {
        path: 'sub-assembly-master',
        data: { assemblyType: 'sub-assembly' },
        loadComponent: () =>
          import('./pages/assembly-master/assembly-master.component').then(
            (m) => m.AssemblyMasterComponent,
          ),
      },
      {
        path: 'main-assembly-master',
        data: { assemblyType: 'main-assembly' },
        loadComponent: () =>
          import('./pages/assembly-master/assembly-master.component').then(
            (m) => m.AssemblyMasterComponent,
          ),
      },
      {
        path: 'machine-assembly-master',
        data: { assemblyType: 'machine-assembly' },
        loadComponent: () =>
          import('./pages/assembly-master/assembly-master.component').then(
            (m) => m.AssemblyMasterComponent,
          ),
      },
      {
        path: 'qc-master/create',
        loadComponent: () =>
          import('./pages/qc-master/qc-checklist-form/qc-checklist-form.component').then(
            (m) => m.QcChecklistFormComponent,
          ),
      },
      {
        path: 'qc-master/edit/:id',
        loadComponent: () =>
          import('./pages/qc-master/qc-checklist-form/qc-checklist-form.component').then(
            (m) => m.QcChecklistFormComponent,
          ),
      },
      {
        path: 'qc-master',
        loadComponent: () =>
          import('./pages/qc-master/qc-master.component').then(
            (m) => m.QcMasterComponent,
          ),
      },
    ],
  },
  {
    path: 'auth',
    component: AuthTemplateComponent,
    canActivate: [GuestGuard],
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./pages/auth/login/login.component').then(
            (m) => m.LoginComponent,
          ),
      },
      { path: '', redirectTo: 'login', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: '' },
];
